


export const ID_TITAN_HEADER = 'header-aaa5776e-8614-48a7-a3a3-27fe0e96e0e7';
export const ID_TITAN_NOTICE = 'notice-fb771f13-0d52-481f-b683-fc9d07df97c0';